  <div class="layer-head">
    <div>
      <i class="usericon icon-info-circled-alt"></i>&nbsp;Hinweis
    </div>
  </div>
  <div class="warningcontent"></div>
  <div class="warningbutton">
    <i class="usericon  icon-check-1-full"></i>&nbsp;OK
  </div>
